import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "STDTDModeler" })((_theme) => ({
  page: {
    margin: "20px",
  },
  STDTDExportBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "10px",
    marginTop: "-30px",
  },
  SaveBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "10px",
    marginTop: "10px",
  },
}));
